import _toConsumableArray from "/var/www/pontevedra4picosroad.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/var/www/pontevedra4picosroad.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import * as React from "react";
import { EVENT_ON_KEY_DOWN, EVENT_ON_KEY_UP, EVENT_ON_POINTER_CANCEL, EVENT_ON_POINTER_DOWN, EVENT_ON_POINTER_LEAVE, EVENT_ON_POINTER_MOVE, EVENT_ON_POINTER_UP, EVENT_ON_WHEEL } from "../consts.js";
export var useSensors = function useSensors() {
  var _React$useState = React.useState({}),
    _React$useState2 = _slicedToArray(_React$useState, 1),
    subscribers = _React$useState2[0];
  return React.useMemo(function () {
    var notifySubscribers = function notifySubscribers(type, event) {
      var _a;
      (_a = subscribers[type]) === null || _a === void 0 ? void 0 : _a.forEach(function (listener) {
        if (!event.isPropagationStopped()) listener(event);
      });
    };
    return {
      registerSensors: {
        onPointerDown: function onPointerDown(event) {
          return notifySubscribers(EVENT_ON_POINTER_DOWN, event);
        },
        onPointerMove: function onPointerMove(event) {
          return notifySubscribers(EVENT_ON_POINTER_MOVE, event);
        },
        onPointerUp: function onPointerUp(event) {
          return notifySubscribers(EVENT_ON_POINTER_UP, event);
        },
        onPointerLeave: function onPointerLeave(event) {
          return notifySubscribers(EVENT_ON_POINTER_LEAVE, event);
        },
        onPointerCancel: function onPointerCancel(event) {
          return notifySubscribers(EVENT_ON_POINTER_CANCEL, event);
        },
        onKeyDown: function onKeyDown(event) {
          return notifySubscribers(EVENT_ON_KEY_DOWN, event);
        },
        onKeyUp: function onKeyUp(event) {
          return notifySubscribers(EVENT_ON_KEY_UP, event);
        },
        onWheel: function onWheel(event) {
          return notifySubscribers(EVENT_ON_WHEEL, event);
        }
      },
      subscribeSensors: function subscribeSensors(type, callback) {
        if (!subscribers[type]) {
          subscribers[type] = [];
        }
        subscribers[type].unshift(callback);
        return function () {
          var listeners = subscribers[type];
          if (listeners) {
            listeners.splice.apply(listeners, [0, listeners.length].concat(_toConsumableArray(listeners.filter(function (el) {
              return el !== callback;
            }))));
          }
        };
      }
    };
  }, [subscribers]);
};